module.exports = __webpack_public_path__ + "static/media/Phantom Assassin.812c565f.png";